import { FETCH_TASK, FETCH_TASKS, MODAL_ACTION, SAVE_TASK, TASK_DATA } from "../Dispatchers";
import { isloading } from "../reducer/LoadingReducer";
import { formatError, formatSuccess } from "../service/AuthService";
import { addComment, fetchAllTasks, fetchAllTasksBoard, getTask, getTaskData, saveTask, updateFile, updateStatus, updateTask } from "../service/TaskService";
import { setLoader } from "../themeSettingSlice";
import { fetchDashboardAction, loaderAction } from "./UserActions";

export const saveTaskAction = (task) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        saveTask(task).then((response) => {
            formatSuccess(response.data);
            dispatch({ type: MODAL_ACTION, payload: true })
            dispatch(fetchDashboardAction())
        }).catch((error) => {
            formatError(error)
            dispatch({ type: MODAL_ACTION, payload: false })
        }).finally(() => {
            dispatch(loaderAction(true))
        })

    }
}
export const updateStatusAction = (task) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        updateStatus(task).then((response) => {
            formatSuccess(response.data);
            dispatch(getTaskAction(task.taskId))
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(true))
        })
    }
}
export const updateStatusBoardAction = (task, filters) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        updateStatus(task).then((response) => {
            formatSuccess(response.data);
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(fetchAllTasksBoardAction(filters))
            dispatch(loaderAction(false))
        })

    }
}
export const addCommentAction = (task) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        addComment(task).then((response) => {
            formatSuccess(response.data);
            dispatch(getTaskAction(task.taskId))
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))

        })
    }
}
export const updateFileAction = (task) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        updateFile(task).then((response) => {
            formatSuccess(response.data);
            dispatch(getTaskAction(task.get("taskId")))
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))
        })
    }
}
export const getTaskAction = (taskId) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        getTask(taskId).then((response) => {
            dispatch({ type: FETCH_TASK, payload: response.data })
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))
        })
    }
}
export const updateTaskAction = (task) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        updateTask(task).then((response) => {
            formatSuccess(response.data);
            dispatch(getTaskAction(task.taskId))
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))
        })
    }
}
export const fetchTaskDataAction = () => {
    return (dispatch) => {
       
        getTaskData().then((response) => {
            dispatch({ type: TASK_DATA, payload: response.data })
        }).catch((error) => {
            formatError(error)
        })
    }
}
export const fetchAllTasksAction = (page, size, filters) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        fetchAllTasks(page, size, filters).then((response) => {
            dispatch({ type: FETCH_TASKS, payload: response.data })
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))
        })
    }
}
export const fetchAllTasksBoardAction = (filters) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        fetchAllTasksBoard(filters).then((response) => {
            dispatch({ type: FETCH_TASKS, payload: response.data })
        }).catch((error) => {
            dispatch(loaderAction(false))
            formatError(error)
        })
    }
}